import * as React from 'react';
import { connect } from 'react-redux';
import { Translate } from '../../../shared/LanguageService';
import * as RegionActions from '../actions/RegionActions';
import RegionForm from '../RegionForm';
import notify from '../../../shared/feedback/notifications';
import { Modal, Button, FormGroup, FormControl, ControlLabel } from 'react-bootstrap';
import { handleError } from '../../../shared/ErrorCatching';

class CreateRegionModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            region: {},
            errors: {},
            creating: false
        };

        this.onChange = this.onChange.bind(this);
        this.create = this.create.bind(this);
        this.formIsValid = this.formIsValid.bind(this);
    }

    render() {
        return (
            <div>
                <Modal show={true} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('create-region/modal/title/create-region')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <RegionForm
                            errors={this.state.errors}
                            region={this.state.region}
                            onChange={this.onChange}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('create-region/modal/footer/button-label/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating || !this.formIsValid()}
                            bsStyle="primary"
                            onClick={this.create}
                        >
                            {this.state.creating
                                ? Translate('create-region/modal/footer/button-label/saving')
                                : Translate('create-region/modal/footer/button-label/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    create() {
        this.setState({ creating: true });
        this.props.actions
            .createRegion(this.state.region)
            .then(() => {
                notify.success(Translate('create-region-success'));
                this.setState({ creating: false });
                this.props.closeModal();
            })
            .catch((error: any) =>
                handleError(error, (errors) => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    onChange(region: any) {
        this.setState({ region: region });
    }

    formIsValid() {
        return this.state.region.name && this.state.region.name.length > 0;
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        regions: state.regions
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            createRegion: (region: any) => dispatch(RegionActions.createRegion(region))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateRegionModal);
